import * as X from "react";
import qr, { forwardRef as Br, useContext as Nt } from "react";
import { css as be } from "@emotion/react";
import { globalColor as je, illaPrefix as Le, applyBoxStyle as At, deleteCssProps as $t } from "@illa-design/theme";
import { LinkIcon as kt } from "@illa-design/icon";
var or = { exports: {} }, me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function It() {
  if (Nr)
    return me;
  Nr = 1;
  var e = qr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, p, m) {
    var d, y = {}, $ = null, k = null;
    m !== void 0 && ($ = "" + m), p.key !== void 0 && ($ = "" + p.key), p.ref !== void 0 && (k = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (f && f.defaultProps)
      for (d in p = f.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: f, key: $, ref: k, props: y, _owner: o.current };
  }
  return me.Fragment = n, me.jsx = l, me.jsxs = l, me;
}
var ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Dt() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = qr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, g = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = N && t[N] || t[g];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), h = 1; h < s; h++)
          u[h - 1] = arguments[h];
        P("error", t, u);
      }
    }
    function P(t, s, u) {
      {
        var h = S.ReactDebugCurrentFrame, R = h.getStackAddendum();
        R !== "" && (s += "%s", u = u.concat([R]));
        var A = u.map(function(_) {
          return String(_);
        });
        A.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, A);
      }
    }
    var I = !1, c = !1, L = !1, O = !1, Ge = !1, xe;
    xe = Symbol.for("react.module.reference");
    function Je(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Ge || t === o || t === m || t === d || O || t === k || I || c || L || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === y || t.$$typeof === l || t.$$typeof === f || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === xe || t.getModuleId !== void 0));
    }
    function Ke(t, s, u) {
      var h = t.displayName;
      if (h)
        return h;
      var R = s.displayName || s.name || "";
      return R !== "" ? u + "(" + R + ")" : u;
    }
    function we(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return we(s) + ".Consumer";
          case l:
            var u = t;
            return we(u._context) + ".Provider";
          case p:
            return Ke(t, t.render, "ForwardRef");
          case y:
            var h = t.displayName || null;
            return h !== null ? h : B(t.type) || "Memo";
          case $: {
            var R = t, A = R._payload, _ = R._init;
            try {
              return B(_(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Q = 0, Ce, Te, ue, Oe, fe, Pe, Ne;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function He() {
      {
        if (Q === 0) {
          Ce = console.log, Te = console.info, ue = console.warn, Oe = console.error, fe = console.group, Pe = console.groupCollapsed, Ne = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Q++;
      }
    }
    function Ze() {
      {
        if (Q--, Q === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: Ce
            }),
            info: H({}, t, {
              value: Te
            }),
            warn: H({}, t, {
              value: ue
            }),
            error: H({}, t, {
              value: Oe
            }),
            group: H({}, t, {
              value: fe
            }),
            groupCollapsed: H({}, t, {
              value: Pe
            }),
            groupEnd: H({}, t, {
              value: Ne
            })
          });
        }
        Q < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = S.ReactCurrentDispatcher, de;
    function re(t, s, u) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (R) {
            var h = R.stack.trim().match(/\n( *(at )?)/);
            de = h && h[1] || "";
          }
        return `
` + de + t;
      }
    }
    var pe = !1, te;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      te = new Xe();
    }
    function v(t, s) {
      if (!t || pe)
        return "";
      {
        var u = te.get(t);
        if (u !== void 0)
          return u;
      }
      var h;
      pe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = le.current, le.current = null, He();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Z) {
              h = Z;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (Z) {
              h = Z;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            h = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && h && typeof Z.stack == "string") {
          for (var b = Z.stack.split(`
`), W = h.stack.split(`
`), D = b.length - 1, F = W.length - 1; D >= 1 && F >= 0 && b[D] !== W[F]; )
            F--;
          for (; D >= 1 && F >= 0; D--, F--)
            if (b[D] !== W[F]) {
              if (D !== 1 || F !== 1)
                do
                  if (D--, F--, F < 0 || b[D] !== W[F]) {
                    var q = `
` + b[D].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && te.set(t, q), q;
                  }
                while (D >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        pe = !1, le.current = A, Ze(), Error.prepareStackTrace = R;
      }
      var oe = t ? t.displayName || t.name : "", Pr = oe ? re(oe) : "";
      return typeof t == "function" && te.set(t, Pr), Pr;
    }
    function ve(t, s, u) {
      return v(t, !1);
    }
    function ne(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ne(t));
      if (typeof t == "string")
        return re(t);
      switch (t) {
        case m:
          return re("Suspense");
        case d:
          return re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return ve(t.render);
          case y:
            return ee(t.type, s, u);
          case $: {
            var h = t, R = h._payload, A = h._init;
            try {
              return ee(A(R), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, yr = {}, Er = S.ReactDebugCurrentFrame;
    function ke(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        Er.setExtraStackFrame(u);
      } else
        Er.setExtraStackFrame(null);
    }
    function ft(t, s, u, h, R) {
      {
        var A = Function.call.bind($e);
        for (var _ in t)
          if (A(t, _)) {
            var b = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((h || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[_](s, _, h, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              b = D;
            }
            b && !(b instanceof Error) && (ke(R), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", u, _, typeof b), ke(null)), b instanceof Error && !(b.message in yr) && (yr[b.message] = !0, ke(R), E("Failed %s type: %s", u, b.message), ke(null));
          }
      }
    }
    var lt = Array.isArray;
    function Qe(t) {
      return lt(t);
    }
    function dt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function pt(t) {
      try {
        return br(t), !1;
      } catch {
        return !0;
      }
    }
    function br(t) {
      return "" + t;
    }
    function gr(t) {
      if (pt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", dt(t)), br(t);
    }
    var he = S.ReactCurrentOwner, vt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _r, Sr, er;
    er = {};
    function ht(t) {
      if ($e.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mt(t) {
      if ($e.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function yt(t, s) {
      if (typeof t.ref == "string" && he.current && s && he.current.stateNode !== s) {
        var u = B(he.current.type);
        er[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(he.current.type), t.ref), er[u] = !0);
      }
    }
    function Et(t, s) {
      {
        var u = function() {
          _r || (_r = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var u = function() {
          Sr || (Sr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var gt = function(t, s, u, h, R, A, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: _,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function _t(t, s, u, h, R) {
      {
        var A, _ = {}, b = null, W = null;
        u !== void 0 && (gr(u), b = "" + u), mt(s) && (gr(s.key), b = "" + s.key), ht(s) && (W = s.ref, yt(s, R));
        for (A in s)
          $e.call(s, A) && !vt.hasOwnProperty(A) && (_[A] = s[A]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (A in D)
            _[A] === void 0 && (_[A] = D[A]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && Et(_, F), W && bt(_, F);
        }
        return gt(t, b, W, R, h, he.current, _);
      }
    }
    var rr = S.ReactCurrentOwner, Rr = S.ReactDebugCurrentFrame;
    function ae(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        Rr.setExtraStackFrame(u);
      } else
        Rr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function nr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function xr() {
      {
        if (rr.current) {
          var t = B(rr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function St(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var wr = {};
    function Rt(t) {
      {
        var s = xr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Cr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Rt(s);
        if (wr[u])
          return;
        wr[u] = !0;
        var h = "";
        t && t._owner && t._owner !== rr.current && (h = " It was passed a child from " + B(t._owner.type) + "."), ae(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, h), ae(null);
      }
    }
    function Tr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (Qe(t))
          for (var u = 0; u < t.length; u++) {
            var h = t[u];
            nr(h) && Cr(h, s);
          }
        else if (nr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = M(t);
          if (typeof R == "function" && R !== t.entries)
            for (var A = R.call(t), _; !(_ = A.next()).done; )
              nr(_.value) && Cr(_.value, s);
        }
      }
    }
    function xt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var h = B(s);
          ft(u, t.props, "prop", h, t);
        } else if (s.PropTypes !== void 0 && !tr) {
          tr = !0;
          var R = B(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function wt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var h = s[u];
          if (h !== "children" && h !== "key") {
            ae(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), ae(null);
            break;
          }
        }
        t.ref !== null && (ae(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Or(t, s, u, h, R, A) {
      {
        var _ = Je(t);
        if (!_) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = St(R);
          W ? b += W : b += xr();
          var D;
          t === null ? D = "null" : Qe(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (B(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, b);
        }
        var F = _t(t, s, u, R, A);
        if (F == null)
          return F;
        if (_) {
          var q = s.children;
          if (q !== void 0)
            if (h)
              if (Qe(q)) {
                for (var oe = 0; oe < q.length; oe++)
                  Tr(q[oe], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Tr(q, t);
        }
        return t === a ? wt(F) : xt(F), F;
      }
    }
    function Ct(t, s, u) {
      return Or(t, s, u, !0);
    }
    function Tt(t, s, u) {
      return Or(t, s, u, !1);
    }
    var Ot = Tt, Pt = Ct;
    ye.Fragment = a, ye.jsx = Ot, ye.jsxs = Pt;
  }()), ye;
}
process.env.NODE_ENV === "production" ? or.exports = It() : or.exports = Dt();
var Ve = or.exports;
function Mt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Ft(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var jt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ft(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = Mt(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", Ye = "-moz-", x = "-webkit-", lr = "comm", dr = "rule", pr = "decl", Lt = "@import", Gr = "@keyframes", Vt = "@layer", Yt = Math.abs, ze = String.fromCharCode, Wt = Object.assign;
function zt(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function Jr(e) {
  return e.trim();
}
function Ut(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function ir(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function ge(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function vr(e) {
  return e.length;
}
function Ie(e, r) {
  return r.push(e), e;
}
function qt(e, r) {
  return e.map(r).join("");
}
var Ue = 1, se = 1, Kr = 0, z = 0, j = 0, ce = "";
function qe(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Ue, column: se, length: l, return: "" };
}
function Ee(e, r) {
  return Wt(qe("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Bt() {
  return j;
}
function Gt() {
  return j = z > 0 ? V(ce, --z) : 0, se--, j === 10 && (se = 1, Ue--), j;
}
function U() {
  return j = z < Kr ? V(ce, z++) : 0, se++, j === 10 && (se = 1, Ue++), j;
}
function K() {
  return V(ce, z);
}
function De() {
  return z;
}
function Re(e, r) {
  return ge(ce, e, r);
}
function _e(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Hr(e) {
  return Ue = se = 1, Kr = J(ce = e), z = 0, [];
}
function Zr(e) {
  return ce = "", e;
}
function Me(e) {
  return Jr(Re(z - 1, sr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Jt(e) {
  for (; (j = K()) && j < 33; )
    U();
  return _e(e) > 2 || _e(j) > 3 ? "" : " ";
}
function Kt(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Re(e, De() + (r < 6 && K() == 32 && U() == 32));
}
function sr(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && sr(j);
        break;
      case 40:
        e === 41 && sr(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function Ht(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && K() === 47)
      break;
  return "/*" + Re(r, z - 1) + "*" + ze(e === 47 ? e : U());
}
function Zt(e) {
  for (; !_e(K()); )
    U();
  return Re(e, z);
}
function Xt(e) {
  return Zr(Fe("", null, null, null, [""], e = Hr(e), 0, [0], e));
}
function Fe(e, r, n, a, o, i, l, f, p) {
  for (var m = 0, d = 0, y = l, $ = 0, k = 0, N = 0, g = 1, M = 1, S = 1, E = 0, P = "", I = o, c = i, L = a, O = P; M; )
    switch (N = E, E = U()) {
      case 40:
        if (N != 108 && V(O, y - 1) == 58) {
          ir(O += w(Me(E), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Me(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Jt(N);
        break;
      case 92:
        O += Kt(De() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            Ie(Qt(Ht(U(), De()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * g:
        f[m++] = J(O) * S;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            S == -1 && (O = w(O, /\f/g, "")), k > 0 && J(O) - y && Ie(k > 32 ? kr(O + ";", a, n, y - 1) : kr(w(O, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (Ie(L = $r(O, r, n, m, d, o, f, P, I = [], c = [], y), i), E === 123)
              if (d === 0)
                Fe(O, r, L, L, I, i, y, f, c);
              else
                switch ($ === 99 && V(O, 3) === 110 ? 100 : $) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Fe(e, L, L, a && Ie($r(e, L, L, 0, 0, o, f, P, o, I = [], y), c), o, c, y, f, a ? I : c);
                    break;
                  default:
                    Fe(O, L, L, L, [""], c, 0, f, c);
                }
        }
        m = d = k = 0, g = S = 1, P = O = "", y = l;
        break;
      case 58:
        y = 1 + J(O), k = N;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && Gt() == 125)
            continue;
        }
        switch (O += ze(E), E * g) {
          case 38:
            S = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            f[m++] = (J(O) - 1) * S, S = 1;
            break;
          case 64:
            K() === 45 && (O += Me(U())), $ = K(), d = y = J(P = O += Zt(De())), E++;
            break;
          case 45:
            N === 45 && J(O) == 2 && (g = 0);
        }
    }
  return i;
}
function $r(e, r, n, a, o, i, l, f, p, m, d) {
  for (var y = o - 1, $ = o === 0 ? i : [""], k = vr($), N = 0, g = 0, M = 0; N < a; ++N)
    for (var S = 0, E = ge(e, y + 1, y = Yt(g = l[N])), P = e; S < k; ++S)
      (P = Jr(g > 0 ? $[S] + " " + E : w(E, /&\f/g, $[S]))) && (p[M++] = P);
  return qe(e, r, n, o === 0 ? dr : f, p, m, d);
}
function Qt(e, r, n) {
  return qe(e, r, n, lr, ze(Bt()), ge(e, 2, -2), 0);
}
function kr(e, r, n, a) {
  return qe(e, r, n, pr, ge(e, 0, a), ge(e, a + 1, -1), a);
}
function ie(e, r) {
  for (var n = "", a = vr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function en(e, r, n, a) {
  switch (e.type) {
    case Vt:
      if (e.children.length)
        break;
    case Lt:
    case pr:
      return e.return = e.return || e.value;
    case lr:
      return "";
    case Gr:
      return e.return = e.value + "{" + ie(e.children, a) + "}";
    case dr:
      e.value = e.props.join(",");
  }
  return J(n = ie(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function rn(e) {
  var r = vr(e);
  return function(n, a, o, i) {
    for (var l = "", f = 0; f < r; f++)
      l += e[f](n, a, o, i) || "";
    return l;
  };
}
function tn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function nn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var an = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = K(), o === 38 && i === 12 && (n[a] = 1), !_e(i); )
    U();
  return Re(r, z);
}, on = function(r, n) {
  var a = -1, o = 44;
  do
    switch (_e(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += an(z - 1, n, a);
        break;
      case 2:
        r[a] += Me(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += ze(o);
    }
  while (o = U());
  return r;
}, sn = function(r, n) {
  return Zr(on(Hr(r), n));
}, Ir = /* @__PURE__ */ new WeakMap(), cn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Ir.get(a)) && !o) {
      Ir.set(r, !0);
      for (var i = [], l = sn(n, i), f = a.props, p = 0, m = 0; p < l.length; p++)
        for (var d = 0; d < f.length; d++, m++)
          r.props[m] = i[p] ? l[p].replace(/&\f/g, f[d]) : f[d] + " " + l[p];
    }
  }
}, un = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, fn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", ln = function(r) {
  return r.type === "comm" && r.children.indexOf(fn) > -1;
}, dn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, f = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = f.length - 1; p >= 0; p--) {
          var m = f[p];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (ln(m))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Xr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, pn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Xr(n[a]))
      return !0;
  return !1;
}, Dr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, vn = function(r, n, a) {
  Xr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Dr(r)) : pn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Dr(r)));
};
function Qr(e, r) {
  switch (zt(e, r)) {
    case 5103:
      return x + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return x + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return x + e + Ye + e + Y + e + e;
    case 6828:
    case 4268:
      return x + e + Y + e + e;
    case 6165:
      return x + e + Y + "flex-" + e + e;
    case 5187:
      return x + e + w(e, /(\w+).+(:[^]+)/, x + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return x + e + Y + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return x + e + Y + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return x + e + Y + w(e, "shrink", "negative") + e;
    case 5292:
      return x + e + Y + w(e, "basis", "preferred-size") + e;
    case 6060:
      return x + "box-" + w(e, "-grow", "") + x + e + Y + w(e, "grow", "positive") + e;
    case 4554:
      return x + w(e, /([^-])(transform)/g, "$1" + x + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, x + "$1"), /(image-set)/, x + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, x + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, x + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + x + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, x + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + x + "$2-$3$1" + Ye + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ir(e, "stretch") ? Qr(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, J(e) - 3 - (~ir(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + x) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + x + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + x + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return x + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return x + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return x + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return x + e + Y + e + e;
  }
  return e;
}
var hn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case pr:
        r.return = Qr(r.value, r.length);
        break;
      case Gr:
        return ie([Ee(r, {
          value: w(r.value, "@", "@" + x)
        })], o);
      case dr:
        if (r.length)
          return qt(r.props, function(i) {
            switch (Ut(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ie([Ee(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Ye + "$1")]
                })], o);
              case "::placeholder":
                return ie([Ee(r, {
                  props: [w(i, /:(plac\w+)/, ":" + x + "input-$1")]
                }), Ee(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Ye + "$1")]
                }), Ee(r, {
                  props: [w(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, mn = [hn], yn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var M = g.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || mn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, f = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var M = g.getAttribute("data-emotion").split(" "), S = 1; S < M.length; S++)
        i[M[S]] = !0;
      f.push(g);
    }
  );
  var p, m = [cn, un];
  process.env.NODE_ENV !== "production" && m.push(dn({
    get compat() {
      return N.compat;
    }
  }), vn);
  {
    var d, y = [en, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== lr && d.insert(g.value + "{}"));
    } : tn(function(g) {
      d.insert(g);
    })], $ = rn(m.concat(o, y)), k = function(M) {
      return ie(Xt(M), $);
    };
    p = function(M, S, E, P) {
      d = E, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + S.map);
        }
      }), k(M ? M + "{" + S.styles + "}" : S.styles), P && (N.inserted[S.name] = !0);
    };
  }
  var N = {
    key: n,
    sheet: new jt({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return N.sheet.hydrate(f), N;
}, cr = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function En() {
  if (Mr)
    return C;
  Mr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function P(c) {
    if (typeof c == "object" && c !== null) {
      var L = c.$$typeof;
      switch (L) {
        case r:
          switch (c = c.type, c) {
            case p:
            case m:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case d:
                case N:
                case k:
                case l:
                  return c;
                default:
                  return L;
              }
          }
        case n:
          return L;
      }
    }
  }
  function I(c) {
    return P(c) === m;
  }
  return C.AsyncMode = p, C.ConcurrentMode = m, C.ContextConsumer = f, C.ContextProvider = l, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = N, C.Memo = k, C.Portal = n, C.Profiler = i, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(c) {
    return I(c) || P(c) === p;
  }, C.isConcurrentMode = I, C.isContextConsumer = function(c) {
    return P(c) === f;
  }, C.isContextProvider = function(c) {
    return P(c) === l;
  }, C.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, C.isForwardRef = function(c) {
    return P(c) === d;
  }, C.isFragment = function(c) {
    return P(c) === a;
  }, C.isLazy = function(c) {
    return P(c) === N;
  }, C.isMemo = function(c) {
    return P(c) === k;
  }, C.isPortal = function(c) {
    return P(c) === n;
  }, C.isProfiler = function(c) {
    return P(c) === i;
  }, C.isStrictMode = function(c) {
    return P(c) === o;
  }, C.isSuspense = function(c) {
    return P(c) === y;
  }, C.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === m || c === i || c === o || c === y || c === $ || typeof c == "object" && c !== null && (c.$$typeof === N || c.$$typeof === k || c.$$typeof === l || c.$$typeof === f || c.$$typeof === d || c.$$typeof === M || c.$$typeof === S || c.$$typeof === E || c.$$typeof === g);
  }, C.typeOf = P, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function bn() {
  return Fr || (Fr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function P(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === m || v === i || v === o || v === y || v === $ || typeof v == "object" && v !== null && (v.$$typeof === N || v.$$typeof === k || v.$$typeof === l || v.$$typeof === f || v.$$typeof === d || v.$$typeof === M || v.$$typeof === S || v.$$typeof === E || v.$$typeof === g);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var ve = v.$$typeof;
        switch (ve) {
          case r:
            var ne = v.type;
            switch (ne) {
              case p:
              case m:
              case a:
              case i:
              case o:
              case y:
                return ne;
              default:
                var ee = ne && ne.$$typeof;
                switch (ee) {
                  case f:
                  case d:
                  case N:
                  case k:
                  case l:
                    return ee;
                  default:
                    return ve;
                }
            }
          case n:
            return ve;
        }
      }
    }
    var c = p, L = m, O = f, Ge = l, xe = r, Je = d, Ke = a, we = N, B = k, H = n, Q = i, Ce = o, Te = y, ue = !1;
    function Oe(v) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), fe(v) || I(v) === p;
    }
    function fe(v) {
      return I(v) === m;
    }
    function Pe(v) {
      return I(v) === f;
    }
    function Ne(v) {
      return I(v) === l;
    }
    function Ae(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function He(v) {
      return I(v) === d;
    }
    function Ze(v) {
      return I(v) === a;
    }
    function le(v) {
      return I(v) === N;
    }
    function de(v) {
      return I(v) === k;
    }
    function re(v) {
      return I(v) === n;
    }
    function pe(v) {
      return I(v) === i;
    }
    function te(v) {
      return I(v) === o;
    }
    function Xe(v) {
      return I(v) === y;
    }
    T.AsyncMode = c, T.ConcurrentMode = L, T.ContextConsumer = O, T.ContextProvider = Ge, T.Element = xe, T.ForwardRef = Je, T.Fragment = Ke, T.Lazy = we, T.Memo = B, T.Portal = H, T.Profiler = Q, T.StrictMode = Ce, T.Suspense = Te, T.isAsyncMode = Oe, T.isConcurrentMode = fe, T.isContextConsumer = Pe, T.isContextProvider = Ne, T.isElement = Ae, T.isForwardRef = He, T.isFragment = Ze, T.isLazy = le, T.isMemo = de, T.isPortal = re, T.isProfiler = pe, T.isStrictMode = te, T.isSuspense = Xe, T.isValidElementType = P, T.typeOf = I;
  }()), T;
}
process.env.NODE_ENV === "production" ? cr.exports = En() : cr.exports = bn();
var gn = cr.exports, et = gn, _n = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Sn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, rt = {};
rt[et.ForwardRef] = _n;
rt[et.Memo] = Sn;
var Rn = !0;
function xn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var tt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Rn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, wn = function(r, n, a) {
  tt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Cn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Tn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, jr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, On = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Pn = /[A-Z]|^ms/g, nt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, hr = function(r) {
  return r.charCodeAt(1) === 45;
}, Lr = function(r) {
  return r != null && typeof r != "boolean";
}, ar = /* @__PURE__ */ nn(function(e) {
  return hr(e) ? e : e.replace(Pn, "-$&").toLowerCase();
}), We = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(nt, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return Tn[r] !== 1 && !hr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Nn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, An = ["normal", "none", "initial", "inherit", "unset"], $n = We, kn = /^-ms-/, In = /-(.)/g, Vr = {};
  We = function(r, n) {
    if (r === "content" && (typeof n != "string" || An.indexOf(n) === -1 && !Nn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = $n(r, n);
    return a !== "" && !hr(r) && r.indexOf("-") !== -1 && Vr[r] === void 0 && (Vr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(kn, "ms-").replace(In, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var at = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(at);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Dn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, l = n(e);
        return G = i, Se(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], p = n.replace(nt, function(d, y, $) {
          var k = "animation" + f.length;
          return f.push("const " + k + " = keyframes`" + $.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + k + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var m = r[n];
  return m !== void 0 ? m : n;
}
function Dn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Se(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Lr(l) && (a += ar(i) + ":" + We(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(at);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var f = 0; f < l.length; f++)
            Lr(l[f]) && (a += ar(i) + ":" + We(i, l[f]) + ";");
        else {
          var p = Se(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += ar(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(On), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Yr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ot;
process.env.NODE_ENV !== "production" && (ot = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Wr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Se(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(jr), i += l[0]);
  for (var f = 1; f < r.length; f++)
    i += Se(a, n, r[f]), o && (process.env.NODE_ENV !== "production" && l[f] === void 0 && console.error(jr), i += l[f]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ot, function($) {
    return p = $, "";
  })), Yr.lastIndex = 0;
  for (var m = "", d; (d = Yr.exec(i)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = Cn(i) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, Mn = function(r) {
  return r();
}, Fn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, jn = Fn || Mn, Be = {}.hasOwnProperty, mr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ yn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (mr.displayName = "EmotionCacheContext");
mr.Provider;
var Ln = function(r) {
  return /* @__PURE__ */ Br(function(n, a) {
    var o = Nt(mr);
    return r(n, o, a);
  });
}, it = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (it.displayName = "EmotionThemeContext");
var zr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Vn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return zr(n[1]);
}, Yn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Wn = function(r) {
  return r.replace(/\$/g, "-");
}, zn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Vn(n[a]);
      if (o) {
        if (Yn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Wn(o);
      }
    }
}, ur = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", fr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", st = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Be.call(n, o) && (a[o] = n[o]);
  if (a[ur] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = zn(new Error().stack);
    i && (a[fr] = i);
  }
  return a;
}, Un = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return tt(n, a, o), jn(function() {
    return wn(n, a, o);
  }), null;
}, ct = /* @__PURE__ */ Ln(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[ur], i = [a], l = "";
  typeof e.className == "string" ? l = xn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var f = Wr(i, void 0, X.useContext(it));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var p = e[fr];
    p && (f = Wr([f, "label:" + p + ";"]));
  }
  l += r.key + "-" + f.name;
  var m = {};
  for (var d in e)
    Be.call(e, d) && d !== "css" && d !== ur && (process.env.NODE_ENV === "production" || d !== fr) && (m[d] = e[d]);
  return m.ref = n, m.className = l, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Un, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, m));
});
process.env.NODE_ENV !== "production" && (ct.displayName = "EmotionCssPropInternal");
var ut = ct;
function Ur(e, r, n) {
  return Be.call(r, "css") ? Ve.jsx(ut, st(e, r), n) : Ve.jsx(e, r, n);
}
function qn(e, r, n) {
  return Be.call(r, "css") ? Ve.jsxs(ut, st(e, r), n) : Ve.jsxs(e, r, n);
}
const Bn = [
  "white",
  "blackAlpha",
  "gray",
  "grayBlue",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "cyan",
  "purple",
  "techPink",
  "techPurple"
];
function Gn(e, r) {
  const n = e == "white" ? je(`--${Le}-white-06`) : je(`--${Le}-grayBlue-09`);
  let a;
  return r && (a = be`
      &:hover {
        background-color: ${n};
      }
    `), be`
    transition: background-color 200ms ease-in-out;
    vertical-align: middle;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    padding: 1px 4px;
    font-size: 14px;
    line-height: 22px;
    ${a};
  `;
}
const Jn = be`
  margin-right: 4px;
`;
function Kn(e, r) {
  const n = Bn.includes(e) ? je(`--${Le}-${e}-02`) : e, a = r ? je(`--${Le}-${e}-05`) : n;
  return be`
    color: ${a};
    cursor: ${r ? "not-allowed" : "pointer"};
  `;
}
const Hn = Br((e, r) => {
  const { disabled: n, icon: a, colorScheme: o = "blue", hoverable: i = !0, ...l } = e, f = typeof a == "boolean" && a ? Ur(kt, {}) : a, p = be`
    ${Gn(o, i)};
    ${Kn(o, n)};
  `;
  return qn("a", { ref: r, css: [p, At(e)], ...$t(l), children: [f && Ur("span", { css: Jn, children: f }), e.children] });
});
Hn.displayName = "Link";
export {
  Hn as Link
};
//# sourceMappingURL=index.js.map
